import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NetSuiteInfo {
  correlationIdSearch: string;
  submitTimeSearch: string;
  typeSearch: string;
  participantNameSearch: string;
  rowsPerPage: number;
  page: number;
}

const initialState: NetSuiteInfo = {
  correlationIdSearch: "",
  submitTimeSearch: "",
  typeSearch: "All",
  participantNameSearch: "All",
  rowsPerPage: 5,
  page: 0,
};

const createNetSuiteLogSlice = createSlice({
  name: "netSuiteLog",
  initialState,
  reducers: {
    setCreateNetSuiteLog: (
      state,
      action: PayloadAction<Partial<NetSuiteInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeNetSuiteLog: () => initialState,
  },
});

export const { setCreateNetSuiteLog, removeNetSuiteLog } =
  createNetSuiteLogSlice.actions;
export default createNetSuiteLogSlice.reducer;
